module.exports = __webpack_public_path__ + "static/media/brlt.a102e563.svg";